import React from 'react';
import { BigPlayButton, Player } from 'video-react';
import 'video-react/dist/video-react.css';

export default props => {
  const { image, videoUrl } = props;
  const { url } = image;

  let src = '';
  if (url) {
    const strippedUrl = url.replace(/^(https?:|)\/\//, '');
    src = `//images.weserv.nl/?url=${strippedUrl}&w=${1200}&q=50&t=squaredown&output=jpg`;
  }

  return (
    <Player playsInline poster={src} src={videoUrl}>
      <BigPlayButton position="center" />
    </Player>
  );
};
